import {createContext, useState} from 'react';

export const useBookingRequest = () => {
  const [formValues, setFormValues] = useState({});
  const {
    adults = 1,
    bookingDate,
    children = 0,
    endTime,
    startTime,
    proposalPrice,
  } = formValues;
  const canEstimateBooking = bookingDate && startTime && endTime && startTime !== endTime && adults >= 1;

  return {
    formValues,
    setFormValues,
    canEstimateBooking
  };
};

export const BookingRequestContext = createContext({
  setFormValues: Function.prototype,
  getCanEstimateBooking: Function.prototype,
  formValues: null,
});
